// removed by extract-text-webpack-plugin
module.exports = {"green-check":"green-check__1Saw5","complete-step-container":"complete-step-container__3vxYV","complete-step":"complete-step__ifm_p","time-remaining":"time-remaining__1G6U3","thank-you":"thank-you__1AwOo","your-application":"your-application__cw4sb","id":"id__1taC2","text":"text__38Muo","see-other-raffles":"see-other-raffles__2Xlk-","arrow":"arrow__3Jg2f","additional-information":"additional-information__3eC6x","go-button":"go-button__2hKKd","redirecting":"redirecting__2ATBj","promoWrapper":"promoWrapper__3Dzs5"};


//////////////////
// WEBPACK FOOTER
// ./routes/thankYou/styles.scss
// module id = Sv/H
// module chunks = 1